import axios from "./axiosInstance";

export async function getEventsInfo(searchQuery: string){


    const params = {
        searchQuery,
    }

    const response = await axios.get(process.env.REACT_APP_BASE_URL + `/templates//eventsInfo`, {params})
    return response.data;
}

export async function getPlayerInfo(player_string?: string, event_id?: string, matchday?: number, competition_id?: string, limit?: number, offset?: number ){


    const params = {
        player: player_string,
        event_id: event_id,
        matchday: matchday,
        competition_id: competition_id,
        limit: limit,
        offset: offset
    }

    const response = await axios.get(process.env.REACT_APP_BASE_URL + `/templates/players`, {params})
    return response.data;
}

export async function getTemplates(player: string, template: string, matchday: number, competition_id: string, event_id: string){
    const params = {
        player: player,
        matchday: matchday,
        competition_id: competition_id,
        template: template,
        event_id: event_id,
    }

    const response = await axios.get(process.env.REACT_APP_BASE_URL + `/templates/templates`, {params})
    return response.data;
}
